import $ from "jquery";
import CyberCookies from "../utils/CyberCookies";
export default class Header {
    static mount() {
        $(function () {
            new Header();
        });
    }
    constructor() {
        this.isMobileView = false;
        this.$element = $("header.wp-block-template-part");
        this.$modal = $("nav.menu-main .wp-block-navigation__responsive-container", this.$element);
        this.$hamburger = $("button.wp-block-navigation__responsive-container-open", "header.wp-block-template-part nav.menu-main");
        this.$topLineContainer = $(".header--container-topline");
        this.$topLineContainerSrcSuccessor = $(this.$element.css("--cm--header--selector--topLineContainerSrcSuccessor"), this.$element);
        this.$topLineContainerDstSuccessor = $(this.$element.css("--cm--header--selector--topLineContainerDstSuccessor"), this.$element);
        this.$footerMenu = $("nav.menu-footer", this.$element);
        this.$socialMediaContainer = $(".social-media-icons-container", this.$element);
        this.$searchToggle = this.$element.find(".wp-block-button.search-toggle a");
        this.$searchToogleContainer = $(".search-toggle-container", this.$element);
        this.$searchToogleContainerSrcSuccessor = $(this.$element
            .css("--cm--header--selector--searchToogleContainerSrcSuccessor")
            .toString(), this.$element);
        this.$searchToogleContainerDstSuccessor = $(this.$element
            .css("--cm--header--selector--searchToogleContainerDstSuccessor")
            .toString(), this.$element);
        this.$searchForm = this.$element.find("form.wp-block-search");
        this.$searchFormSrcSuccessor = $(this.$element
            .css("--cm--header--selector--searchFormSrcSuccessor")
            .toString(), this.$element);
        this.$searchFormDstSuccessor = $(this.$element
            .css("--cm--header--selector--searchFormDstSuccessor")
            .toString(), this.$element);
        this.$searchInput = $(".wp-block-search__input", this.$searchForm);
        this.disableWpDefaultFocusout();
        this.registerEvents();
        if (CyberCookies.isContrastEnabled()) {
            $("html").addClass("contrast");
            this.$element.find(".wp-block-button.contrast").addClass("is-active");
        }
        // reduce flicker
        setTimeout(() => {
            $(".header--nav-container").css("display", "flex");
        }, 0);
    }
    disableWpDefaultFocusout() {
        this.$modal[0].addEventListener("focusout", function (evt) {
            evt.stopImmediatePropagation();
            evt.stopPropagation();
        }, true);
    }
    registerEvents() {
        this.registerHamburgerClick();
        this.registerScrollEvent();
        this.registerResizeEvent();
        this.registerContrastClick();
        this.registerSearchEvents();
    }
    registerSearchEvents() {
        this.$searchToggle.on("click", (event) => {
            this.$searchForm.toggleClass("is-visible");
            this.$searchInput.trigger("focus");
            return true;
        });
        /*
        $searchInput.on('focusout', (event) => {
          $searchInput.removeClass('is-visible');
        });
        */
    }
    registerContrastClick() {
        this.$element.find(".wp-block-button.contrast a").on("click", function () {
            $(this).parent().toggleClass("is-active");
            $("html").toggleClass("contrast");
            if ($("html").hasClass("contrast")) {
                CyberCookies.setContrastEnabled(true);
            }
            else {
                CyberCookies.setContrastEnabled(false);
            }
        });
    }
    checkForSticky() {
        // timeout for anchor scroll
        setTimeout(() => {
            const d = $(document);
            const scroll = d.scrollTop();
            if (scroll !== undefined && scroll > 0) {
                $("header.wp-block-template-part").addClass("sticky");
            }
            else {
                $("header.wp-block-template-part").removeClass("sticky");
            }
        }, 200);
    }
    registerScrollEvent() {
        const d = $(document);
        d.on("scroll", () => {
            this.checkForSticky();
        });
    }
    registerHamburgerClick() {
        this.$hamburger[0].addEventListener("click", (evt) => {
            this.toggleMenu();
            evt.stopImmediatePropagation(); // WP default seems to interfer with this' class behavior
        }, true); // true = while capturing
    }
    registerResizeEvent() {
        let resize = () => {
            const breakpointXl = getComputedStyle(document.documentElement).getPropertyValue("--bs-breakpoint-xl");
            if (window.matchMedia(`(min-width: ${breakpointXl})`).matches) {
                this.closeMenu();
                this.disableMobileView();
            }
            else {
                this.enableMobileView();
            }
        };
        $(window).on("resize", () => {
            resize();
        });
        resize();
    }
    toggleMenu() {
        if (this.isMenuOpen()) {
            this.closeMenu();
        }
        else {
            this.openMenu();
        }
    }
    isMenuOpen() {
        return $(document.documentElement).hasClass("has-modal-open");
    }
    closeMenu() {
        this.hideMenu();
    }
    openMenu() {
        this.showMenu();
    }
    hideMenu() {
        this.$modal.removeClass("has-modal-open is-menu-open");
        $(document.body).find("main").css("visibility", "unset");
        $(document.documentElement).removeClass("has-modal-open"); // WP add's this class to prevent scrolling -> remove it again to re-enable scrolling
    }
    showMenu() {
        $(document.documentElement).addClass("has-modal-open"); // see comment in .hideMenu(), just for consistency add it here, too
        $(document.body).find("main").css("visibility", "hidden"); // avoid z-indexed elements of heroheader hovering over the menu
        this.$modal.addClass("has-modal-open is-menu-open");
    }
    disableMobileView() {
        if (this.isMobileView) {
            this.isMobileView = false;
            this.$topLineContainer.detach();
            this.$topLineContainerSrcSuccessor.before(this.$topLineContainer);
            this.$footerMenu.hide();
            this.$socialMediaContainer.hide();
            this.$searchForm.detach();
            this.$searchFormSrcSuccessor.after(this.$searchForm);
            this.$searchToogleContainer.detach();
            this.$searchToogleContainerSrcSuccessor.after(this.$searchToogleContainer);
        }
    }
    enableMobileView() {
        if (!this.isMobileView) {
            // next render loop to fix with mobile bug
            setTimeout(() => {
                $("#wpadminbar").remove();
                $("body").removeClass("admin-bar");
                this.isMobileView = true;
                this.$footerMenu.detach();
                this.$topLineContainer.detach();
                this.$socialMediaContainer.detach();
                this.$topLineContainerDstSuccessor.before(this.$footerMenu);
                this.$topLineContainerDstSuccessor.before(this.$topLineContainer);
                this.$topLineContainerDstSuccessor.after(this.$socialMediaContainer);
                this.$footerMenu.show();
                this.$socialMediaContainer.show();
                this.$searchForm.detach();
                this.$searchFormDstSuccessor.after(this.$searchForm);
                this.$searchToogleContainer.detach();
                this.$searchToogleContainerDstSuccessor.after(this.$searchToogleContainer);
            }, 0);
        }
    }
}
